{
    "Profile_Vehicles_VehicleUse.vehicleUsage": "FR: Vehicle Usage",
    "Profile_Vehicles_VehicleUse.driverDetails": "FR: Driver Details",
    "Profile_Vehicles_VehicleUse.driver": "FR: Driver",
    "Profile_Vehicles_VehicleUse.usePercentage": "FR: Use Percentage",
    "Profile_Vehicles_VehicleUse.primaryDriver": "FR: Primary Driver",
    "Profile_Vehicles_VehicleUse.vehicleOwner": "FR: Vehicle Owner"
}
